var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'message-abstract-text',
    ("message-abstract-text-" + _vm.highlightType),
    ("message-abstract-text-" + _vm.displayType) ]},_vm._l((_vm.contentText),function(contentItem,index){return _c('span',{key:index,class:[(contentItem && contentItem.isHighlight) ? 'highlight' : 'normal']},[_vm._v(" "+_vm._s(_vm.transformTextWithKeysToEmojiNames(contentItem.text))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }